import * as tslib_1 from "tslib";
import { BaseFrameworkAdaptor } from './BaseFrameworkAdaptor';
/**
 * This class provides the Connect client framework adaptor implementation for CaaS.
 */
var CaaSFrameworkAdaptor = /** @class */ (function (_super) {
    tslib_1.__extends(CaaSFrameworkAdaptor, _super);
    function CaaSFrameworkAdaptor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CaaSFrameworkAdaptor.prototype.registerModuleWithHost = function (moduleName, simpleXdmDefinition) {
        // Removing the dependency on connect-client to ensure we don't bloat out the size of
        // the code unnecessarily. The following line will be re-instated during the migration
        // to CaaS.
        //defineModule(moduleName, simpleXdmDefinition);
    };
    return CaaSFrameworkAdaptor;
}(BaseFrameworkAdaptor));
/**
 * Use only this instance of CaaSFrameworkAdaptor.
 */
export var caasFrameworkAdaptor = new CaaSFrameworkAdaptor();
//# sourceMappingURL=CaaSFrameworkAdaptor.js.map